export var ActiveLocales;
(function (ActiveLocales) {
    ActiveLocales["EN_US"] = "en-US";
    ActiveLocales["ES_US"] = "es-US";
    ActiveLocales["EN_CA"] = "en-CA";
    ActiveLocales["FR_CA"] = "fr-CA";
})(ActiveLocales || (ActiveLocales = {}));
